import React from "react";
import { Link } from "react-router-dom";

export default function ColumnBlock({
  title = "Title",
  text = "Text",
  courseList = [],
  checkAuth = () => {},
}) {
  return (
    <div className="learn_columns_block">
      <h2 className="learn_columns_title">{title}</h2>
      <div className="learn_columns_row row">
        <div className="col-12 col-md-6 mt-4">
          <ul className="learn_group">
            {courseList.map((i, idx) => (
              <li key={i.id} className="learn_group_item" onClick={checkAuth}>
                 {i.title}
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12 col-md-6 mt-4">{text}</div>
      </div>
    </div>
  );
}
